// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35YT2","location":"Header_location__1yqrY"};